import React from 'react';
import dynamic from 'next/dynamic'

const IpynbRenderer = dynamic(() => import('react-ipynb-renderer').then((mod) => mod.IpynbRenderer), {
    ssr: false
  });

import "react-ipynb-renderer/dist/styles/default.css";

import * as Styled from './styled';

import { IRepositoryFile } from '@/types';

const NotebookFileView: React.FC<{ file: IRepositoryFile }> = ({ file }) => {
    return (
        <Styled.NotebookFileView>
        <IpynbRenderer ipynb={file.data} syntaxTheme={'prism'}/>
        </Styled.NotebookFileView>
    );
};

export default NotebookFileView;